import React from "react";

export default function InputField({ label, type = "text", value, onChange }) {
    return (
        <div className="mb-4">
            <label className="block text-sm text-gray-300 mb-1">{label}</label>
            <input
                type={type}
                value={value}
                onChange={onChange}
                className="w-full px-3 py-2 bg-gray-800 rounded-lg text-white 
                 border border-gray-700 focus:outline-none focus:ring-2 
                 focus:ring-primary"
            />
        </div>
    );
}
